import type { ReactNode } from 'react';
import LoadingSpinner from '@components/LoadingSpinner';
import PlaceholderImage from '@components/PlaceholderImage';
import type { Image } from '@/hooks/useLoadImage';

interface ImageStateRendererProps {
  image: Image;
  /** Rendered once the image is ready. */
  children: ReactNode;
}

/**
 * Gates rendering on the state of a loaded image: a centred loader while
 * pending, a placeholder on error, and the children once it is ready. Keeps the
 * three-way branch out of every preview component.
 */
const ImageStateRenderer = ({ image, children }: ImageStateRendererProps) => {
  if (image.isError) return <PlaceholderImage />;
  if (!image.isLoaded || !image.image) {
    return (
      <div className='eye:flex eye:h-full eye:items-center eye:justify-center'>
        <LoadingSpinner />
      </div>
    );
  }

  return <>{children}</>;
};

export default ImageStateRenderer;
